<template>
  <v-chip v-if="stateInfo" :small="!xSmall" :x-small="xSmall" :color="stateInfo.color" dark>
    {{ stateInfo.label }}
  </v-chip>
</template>

<script lang="ts">
import { IVehicle } from "@/models/vehicle.entity";
import { VehicleModule } from "@/store/modules/vehicle.store";
import { $t } from "@/lib/utility/t";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class VehicleStateChip extends Vue {
  @Prop()
  vehicle!: IVehicle;

  @Prop({ default: false })
  xSmall!: boolean;

  get stateInfo() {
    if (this.vehicle.deleted) {
      return { color: "black", label: $t("common.states.deleted") };
    }

    if (!this.vehicle.state) {
      return undefined;
    }

    const state = VehicleModule.stateMap.get(this.vehicle.state);
    if (!state) {
      return undefined;
    }

    return { color: state.color, label: $t(state.label) };
  }
}
</script>
